<template>
  <span v-resize="checkMobile">
    <plan-gate service="services" />
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <v-card>
      <v-card-title class="start-tour-repairs-1">
        <v-flex md12 class="d-flex justify-between">
          <v-flex :class="isMobile ? '' : 'd-flex justify-center align-middle'">
            <v-flex :class="isMobile ? 'd-flex justify-center align-middle' : 'd-flex justify-end align-middle'">
              <h2 v-if="!isMobile">{{ $t("maintenance.payments") }}</h2>
              <h4 v-else>{{ $t("maintenance.payments") }}</h4>
              <v-btn icon color="success" class="ml-2" @click="showNewMaintenanceDialog = true">
                <v-icon>mdi-plus-circle-outline</v-icon>
              </v-btn>
              <v-btn icon :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
                }/${$root.$i18n.locale}/categories/7/guides/23`" target="_blank">
                <v-icon>mdi-help-circle</v-icon>
              </v-btn>
            </v-flex>
            <v-flex class="d-flex justify-center align-middle">
              <v-checkbox v-model="showAllMaintenance" :label="$t('maintenance.show_all_maintenance')" hide-details
                class="ml-2 mt-0"></v-checkbox>
            </v-flex>
          </v-flex>
        </v-flex>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
        <v-flex>
          <v-text-field v-model="search_maintenance" class="mb-2" append-icon="mdi-magnify" :label="$t('custom.search')"
            single-line clearable hide-details hide-no-data></v-text-field>
        </v-flex>
        <v-data-table :headers="headers_with_maintenance" :items="cars_with_maintenance" :loading="isLoading"
          :loading-text="$t('custom.loading_table')" mobile-breakpoint="100" :expanded.sync="expandedColumns"
          :show-expand="false" single-expand :search="search_maintenance" :custom-filter="customSearch"
          :custom-sort="customSort" :items-per-page="50">
          <template slot="item" slot-scope="props">
            <tr>
              <td class="text-center pb-2">
                <router-link style="text-decoration: none;" :to="{ path: `/cars/${props.item.id}` }">
                  <span style="text-decoration: underline !important;" class="subtitle-1">{{ props.item.car_name
                    }}</span>
                  <br>
                  <span class="success--text mr-2">{{ props.item.code }}</span>
                  <span class="info--text">{{ props.item.number }}</span>
                </router-link>
                <br>
                <v-flex class="d-flex justify-center align-middle">
                  <code>{{ props.item.mileage }}</code>
                </v-flex>
              </td>
              <td class="text-center">
                <v-alert v-for="item in props.item.maintenances" :key="item.id" border="left"
                  :color="selectCriticalityClass(item.criticality)" dense dark
                  :class="item.started || showAllMaintenance ? 'my-2 white--text' : 'my-2 white--text hidden'"
                  style="cursor: pointer" @click="maintenance = item, showEndMaintenance()"
                  :icon="checkMaintenanceIcon(item)">
                  {{ item.title }} - {{ nextMaintenance(item) }}
                </v-alert>
              </td>
              <td class="text-center">
                <!-- expend icon -->

                <v-icon v-if="expandedColumns.includes(props.item)"
                  @click="expandedColumns = expandedColumns.filter((i) => i.id !== props.item.id)">
                  mdi-chevron-up
                </v-icon>
                <v-icon v-else @click="expandedColumns.push(props.item)">
                  mdi-chevron-down
                </v-icon>
              </td>
            </tr>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-data-table :headers="maintenance_headers" :loading="isLoading"
                :loading-text="$t('custom.loading_table')" :items="item.maintenances" sort-by="id" sort-desc
                item-key="id" mobile-breakpoint="100" :class="!isMobile ? '' : 'is-mobile'" dense disable-pagination
                hide-default-footer>
                <template slot="item" slot-scope="props">
                  <tr :class="selectCriticalityClass(props.item.criticality)">
                    <td class="text-center" :key="props.item.id">
                      <v-icon v-if="props.item.periodic" color="white">
                        mdi-infinity
                      </v-icon>
                      <v-icon v-else color="white">
                        mdi-repeat-once
                      </v-icon>
                    </td>
                    <td class="text-center" nowrap>
                      {{ formatDate(props.item.date_start) }}
                    </td>
                    <td class="text-center">
                      {{ props.item.title }}
                    </td>
                    <td class="text-center">
                      {{ props.item.description }}
                    </td>
                    <td class="text-center">
                      {{ props.item.days_step }}
                    </td>
                    <td class="text-center">
                      {{ props.item.last_maintenanced_date ? formatDate(props.item.last_maintenanced_date) : '-' }}
                    </td>
                    <td class="text-center">
                      {{ nextMaintenance(props.item) }}
                    </td>
                    <td class="text-center">
                      {{ findWorkersName(props.item.responsible) }}
                    </td>
                    <td class="text-center" nowrap>
                      <v-btn v-if="props.item.date_start" icon color="success"
                        @click="maintenance = props.item, showEndMaintenance()">
                        <v-icon>mdi-check-all</v-icon>
                      </v-btn>
                      <v-btn v-if="props.item.id" icon
                        @click="maintenance = props.item, showEditMaintenanceDialog = true">
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-btn>
                      <v-btn icon :color="props.item.criticality == 2 ? 'white' : 'error'"
                        @click="deleteMaintenance(props.item)">
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
                <template slot="no-data">
                  {{ $t("custom.no_data_in_table") }}
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
                  {{ $t("tables.no_search_result", { msg: search_maintenance }) }}
                </v-alert>
              </v-data-table>
            </td>
          </template>
          <template slot="no-data">
            {{ $t("custom.no_data_in_table") }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="showNewMaintenanceDialog" :retain-focus="false" persistent max-width="600px"
      :fullscreen="isMobile ? true : false">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          {{ $t("maintenance.payment_reminder") }}
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="showNewMaintenanceDialog = false">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-divider class="mb-2"></v-divider>
        <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-flex md12 :class="isMobile ? '' : 'd-flex'">
            <v-flex>
              <v-radio-group v-model="maintenance.periodic">
                <v-radio :label="$t('maintenance.periodic_payment')" :value="true"></v-radio>
                <v-radio :label="$t('maintenance.once_payment')" :value="false"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex v-if="!maintenance.periodic">
              <v-radio-group v-model="maintenance.started">
                <v-radio :label="$t('maintenance.started_payment')" :value="true"></v-radio>
                <v-radio :label="$t('maintenance.future_payment')" :value="false"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-flex>
          <v-flex md12>
            <v-select v-model="maintenance.criticality" :items="maintenance_criticalities" item-text="text"
              item-value="value" dense outlined :label="$t('maintenance.criticality')"></v-select>
          </v-flex>
          <v-flex md12>
            <v-text-field v-model="maintenance.title" :label="$t('maintenance.title')" outlined dense></v-text-field>
          </v-flex>
          <v-flex md12 class="mb-6" v-if="(!maintenance.started || maintenance.periodic)">
            <v-menu offset-y :close-on-content-click="false" max-width="252px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-bind="attrs" v-on="on" readonly
                  :value="formatLastMaintenancedDate(maintenance.last_maintenanced_date)" :attributes="attrs_calendar"
                  :label="$t('maintenance.last_payment_date')" outlined hide-details dense></v-text-field>
              </template>
              <vc-date-picker v-model="maintenance.last_maintenanced_date" mode="date" :masks="{ input: 'YYYY-MM-DD' }"
                :locale="$i18n.locale" @dayclick="updateDaysStemp()">
              </vc-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md12 class="mb-6" v-if="(!maintenance.started || maintenance.periodic)">
            <v-menu offset-y :close-on-content-click="false" max-width="252px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-bind="attrs" v-on="on" readonly
                  :value="formatLastMaintenancedDate(maintenance.next_maintenance_date)" :attributes="attrs_calendar"
                  :label="$t('maintenance.next_payment_date')" outlined hide-details dense></v-text-field>
              </template>
              <vc-date-picker v-model="maintenance.next_maintenance_date" mode="date" :masks="{ input: 'YYYY-MM-DD' }"
                :locale="$i18n.locale" @dayclick="updateDaysStemp()">
              </vc-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md12 v-if="(!maintenance.started || maintenance.periodic)">
            <v-text-field v-model="maintenance.days_step" :label="$t('maintenance.days_step_payments')" type="number"
              outlined dense readonly></v-text-field>
          </v-flex>
          <v-flex md12 v-if="(!maintenance.started || maintenance.periodic)">
            <v-text-field v-model="maintenance.notify_before" :label="$t('maintenance.notify_before')" type="number"
              dense outlined></v-text-field>
          </v-flex>
          <v-flex md12 class="d-flex align-middle mb-5">
            <v-autocomplete v-model="maintenance.responsible" item-text="name" item-value="id"
              :loading="isLoadingResponsible" text hide-no-data hide-details outlined dense multiple clearable
              :label="$t('maintenance.responsible')" :items="workers">
            </v-autocomplete>
            <v-btn icon color="success" @click="maintenance.responsible = workers.map((worker) => worker.id)"
              class="ml-2" v-tooltip="{
                content: $t('counts.select_all_groups'),
                placement: 'top-center',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                delay: {
                  show: 1000,
                  hide: 500,
                },
              }">
              <v-icon>mdi-check-all</v-icon>
            </v-btn>
          </v-flex>
          <v-flex md12 class="d-flex align-middle mb-5">
            <v-autocomplete v-model="maintenance.car_ids" item-text="code" item-value="id" outlined multiple clearable
              dense hide-no-data hide-details :label="$t('custom.select_car')" :items="cars_with_maintenance">
              <template slot="selection" slot-scope="data">
                <!-- HTML that describe how select should render selected items -->
                {{ carLabel(data.item) }}
              </template>
              <template slot="item" slot-scope="data">
                <!-- HTML that describe how select should render items when the select is open -->
                {{ carLabel(data.item) }}
              </template>
            </v-autocomplete>
            <v-btn icon color="success" @click="maintenance.car_ids = cars_with_maintenance.map((car) => car.id)"
              class="ml-2" v-tooltip="{
                content: $t('counts.select_all_groups'),
                placement: 'top-center',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                delay: {
                  show: 1000,
                  hide: 500,
                },
              }">
              <v-icon>mdi-check-all</v-icon>
            </v-btn>
          </v-flex>
          <v-flex md12>
            <v-textarea v-model="maintenance.description" :label="$t('maintenance.description')" outlined rows="1"
              auto-grow dense></v-textarea>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showNewMaintenanceDialog = false">{{
            $t("custom.close")
            }}</v-btn>
          <v-btn color="success" @click="saveMaintenance()">{{
            $t("custom.save")
            }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showEndMaintenanceDialog" :retain-focus="false" persistent max-width="600px"
      :fullscreen="isMobile ? true : false">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          {{ $t("maintenance.end_payment") }}
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="showEndMaintenanceDialog = false">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-divider class="mb-2"></v-divider>
        <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-flex md12 class="mb-6 mt-6">
            <v-menu offset-y :close-on-content-click="false" max-width="252px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-bind="attrs" v-on="on"
                  :value="maintenance.start_insurance_date ? formatLastMaintenancedDate(maintenance.start_insurance_date) : $t('maintenance.last_payment_date')"
                  :label="$t('maintenance.last_payment_date')" :attributes="attrs_calendar" outlined
                  hide-details></v-text-field>
              </template>
              <vc-date-picker v-model="maintenance.start_insurance_date" mode="date" :masks="{ input: 'YYYY-MM-DD' }"
                :locale="$i18n.locale">
              </vc-date-picker>
            </v-menu>
          </v-flex>
          <v-flex v-if="maintenance.periodic" md12 class="mb-6">
            <v-menu offset-y :close-on-content-click="false" max-width="252px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-bind="attrs" v-on="on" readonly :attributes="attrs_calendar"
                  :value="maintenance.end_insurance_date ? formatLastMaintenancedDate(maintenance.end_insurance_date) : $t('maintenance.next_payment_date')"
                  :label="$t('maintenance.next_payment_date')" outlined hide-details></v-text-field>
              </template>
              <vc-date-picker v-model="maintenance.end_insurance_date" mode="date" :masks="{ input: 'YYYY-MM-DD' }"
                :locale="$i18n.locale">
              </vc-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md12>
            <v-textarea v-model="maintenance.description" :label="$t('maintenance.description')" outlined rows="1"
              auto-grow></v-textarea>
          </v-flex>
          <v-flex md12>
            <v-autocomplete v-model="maintenance.contractor_id" item-text="short_name" item-value="id"
              :loading="isLoadingContractors" :search-input.sync="search_contractor" outlined clearable hide-no-data
              hide-details :label="$t('contractors.select_contractor')" :items="contractors">
            </v-autocomplete>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showEndMaintenanceDialog = false">{{
            $t("custom.close")
            }}</v-btn>
          <v-btn color="success" @click="saveEndInsurance()">{{
            $t("maintenance.end_payment_notify")
            }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showEditMaintenanceDialog" :retain-focus="false" persistent max-width="600px"
      :fullscreen="isMobile ? true : false">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          {{ $t("maintenance.edit_payment_notify") }}
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="showEditMaintenanceDialog = false">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-flex md12>
            <v-radio-group v-model="maintenance.started">
              <v-radio :label="$t('maintenance.started_payment')" :value="true"
                @change="addStartDateToMaintenance(maintenance)"></v-radio>
              <v-radio :label="$t('maintenance.future_payment')" :value="false"></v-radio>
            </v-radio-group>
            <!-- <v-select
              v-model="maintenance.started"
              :items="maintenance_started_states"
              item-text="text"
              item-value="value"
              dense
              outlined
            ></v-select> -->
          </v-flex>
          <v-flex md12>
            <v-select v-model="maintenance.criticality" :items="maintenance_criticalities" item-text="text"
              item-value="value" dense outlined :label="$t('maintenance.criticality')"></v-select>
          </v-flex>
          <v-flex md12>
            <v-text-field v-model="maintenance.title" :label="$t('maintenance.title')" outlined dense></v-text-field>
          </v-flex>
          <v-flex md12 class="mb-6">
            <v-menu offset-y :close-on-content-click="false" max-width="252px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-bind="attrs" v-on="on" readonly
                  :value="formatLastMaintenancedDate(maintenance.last_maintenanced_date)" :attributes="attrs_calendar"
                  :label="$t('maintenance.last_payment_date')" outlined hide-details dense></v-text-field>
              </template>
              <vc-date-picker v-model="maintenance.last_maintenanced_date" mode="date" :masks="{ input: 'YYYY-MM-DD' }"
                :locale="$i18n.locale" @dayclick="updateDaysStemp()">
              </vc-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md12 class="mb-6">
            <v-menu offset-y :close-on-content-click="false" max-width="252px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-bind="attrs" v-on="on" readonly
                  :value="formatLastMaintenancedDate(maintenance.next_maintenance_date)" :attributes="attrs_calendar"
                  :label="$t('maintenance.next_payment_date')" outlined hide-details dense></v-text-field>
              </template>
              <vc-date-picker v-model="maintenance.next_maintenance_date" mode="date" :masks="{ input: 'YYYY-MM-DD' }"
                :locale="$i18n.locale" @dayclick="updateDaysStemp()">
              </vc-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md12>
            <v-textarea v-model="maintenance.description" :label="$t('maintenance.description')" outlined rows="1"
              auto-grow dense></v-textarea>
          </v-flex>
          <v-flex md12>
            <v-text-field v-model="maintenance.days_step" :label="$t('maintenance.days_step_payments')" type="number"
              outlined dense></v-text-field>
          </v-flex>
          <v-flex md12>
            <v-text-field v-model="maintenance.notify_before" :label="$t('maintenance.notify_before')" type="number"
              dense outlined></v-text-field>
          </v-flex>
          <v-flex md12 class="d-flex align-middle">
            <v-autocomplete v-model="maintenance.responsible" item-text="name" item-value="id"
              :loading="isLoadingResponsible" text hide-no-data hide-details outlined dense multiple clearable
              :label="$t('maintenance.responsible')" :items="workers">
            </v-autocomplete>
            <v-btn icon color="success" @click="maintenance.responsible = workers.map((worker) => worker.id)"
              class="ml-2" v-tooltip="{
                content: $t('counts.select_all_groups'),
                placement: 'top-center',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                delay: {
                  show: 1000,
                  hide: 500,
                },
              }">
              <v-icon>mdi-check-all</v-icon>
            </v-btn>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showEditMaintenanceDialog = false">{{
            $t("custom.close")
            }}</v-btn>
          <v-btn color="success" @click="saveEditMaintenance()">{{
            $t("custom.save")
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import { carLabel } from "@/utils/carLabel";
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { Capacitor } from "@capacitor/core";
import PullToRefresh from "pulltorefreshjs";
export default {
  data() {
    return {
      cars: [],
      cars_with_maintenance: [],
      responsible: [],
      maintenance: {
        periodic: true,
        started: false,
        maintenance_type: 5,
        title: null,
        description: null,
        mileage_step: 0,
        days_step: 0,
        last_maintenanced_date: moment().format("YYYY-MM-DD"),
        criticality: 0,
        responsible: [],
        assign_to_all_cars: false,
        car_id: null,
        car_ids: [],
        notify_before: 0,
        start_insurance_date: null,
        end_insurance_date: null,
      },
      maintenance_items: [],
      maintenance_headers: [
        { text: '', value: "maintenance_type", align: "center" },
        { text: this.$t('maintenance.date_start'), value: "date_start", align: "center" },
        { text: this.$t('maintenance.title'), value: "title", align: "center" },
        { text: this.$t('maintenance.description'), value: "description", align: "center" },
        { text: this.$t('maintenance.step'), sortable: false, align: "center" },
        { text: this.$t('maintenance.last_maintenance'), sortable: false, align: "center" },
        { text: this.$t('maintenance.next_maintenance_date'), sortable: false, align: "center" },
        { text: this.$t('maintenance.responsible'), value: "responsible", align: "center" },
        { text: this.$t('custom.control'), sortable: false, align: "center" },
      ],
      search_maintenance: null,
      contractor: {},
      contractors: [],
      isLoadingContractors: false,
      search_contractor: null,
      maintenance_types: [
        { text: this.$t("maintenance.mileage"), value: 0 },
        { text: this.$t("maintenance.days"), value: 1 },
        { text: this.$t("maintenance.once"), value: 3 },
        { text: this.$t("maintenance.insurances_and_taxes"), value: 4 },
      ],
      maintenance_criticalities: [
        { text: this.$t("maintenance.low"), value: 0 },
        { text: this.$t("maintenance.medium"), value: 1 },
        { text: this.$t("maintenance.high"), value: 2 },
      ],
      maintenance_started_states: [
        { text: this.$t("maintenance.started_payment"), value: true },
        { text: this.$t("maintenance.future_payment"), value: false },
      ],
      workers: [],
      expandedColumns: [],
      editedCar: [],
      headers_with_maintenance: [
        { text: this.$t("cars.name"), value: "code", align: "center" },
        { text: this.$t("custom.current"), sortable: false, align: "center" },
        { text: '', value: 'data-table-expand' },
      ],
      attrs_calendar: [
        {
          key: "today",
          highlight: {
            color: "blue",
            fillMode: "outline",
            contentClass: "italic",
          },
          dates: new Date(),
        },
      ],
      showEndMaintenanceDialog: false,
      showEditMaintenanceDialog: false,
      showNewMaintenanceDialog: false,
      isLoadingResponsible: false,
      showAllMaintenance: false,
      timeout: null,
      isMobile: false,
      isLoading: true,
      isLoadingSubscribeToPaidTariff: false,
      error: "",
    };
  },
  mounted() {
    let self = this;
    const ptr = PullToRefresh.init({
      mainElement: "body",
      distIgnore: 100,
      instructionsPullToRefresh: this.$t("custom.pull_to_refresh"),
      instructionsReleaseToRefresh: this.$t("custom.release_to_refresh"),
      instructionsRefreshing: this.$t("custom.refreshing"),
    });
  },
  created() {
    let self = this;
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      if (this.user_role == "partner") {
        this.checkPartnerAccess();
      }
      this.isLoading = true;
      this.axios
        .get(`/api/v1/payments_notify`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.cars_with_maintenance = response.data.cars || [];
          this.cars_with_maintenance.forEach((car) => {
            car.maintenances = response.data.maintenances.filter(
              (maintenance) => maintenance.car_id == car.id
            );
          });
          // sort car with nearest maintenance
          this.cars_with_maintenance.sort((a, b) => {
            if (a.maintenances.length > 0 && b.maintenances.length > 0) {
              return (
                moment(a.maintenances[0].date_start).diff(
                  moment(b.maintenances[0].date_start)
                ) > 0
              );
            } else {
              return false;
            }
          });
          this.workers = response.data.workers_names;
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  watch: {
    search_contractor() {
      if (this.contractor && this.contractor.id) {
        return;
      }
      if (this.search_contractor == "" || this.search_contractor == " ") {
        this.search_contractor = null;
      } else {
        let self = this;
        function debounce() {
          if (self.timeout) clearTimeout(self.timeout);

          self.timeout = setTimeout(() => {
            // your action
            self.loadContractors();
          }, 200); // delay
        }
        debounce();
      }
    },
  },
  computed: {
    userMustChangeTariffPlan() {
      if (this.$store.getters.getMainCompany) {
        if (this.$store.getters.getMainCompany.plan && this.$store.getters.getMainCompany.plan.id) {
          if(this.$store.getters.getMainCompany.plan.name == "Старт" || this.$store.getters.getMainCompany.plan.name == "Start") {
            if(this.$store.getters.getMainCompany.plan.trial_end && moment(this.$store.getters.getMainCompany.plan.trial_end).isAfter(moment())) {
              return false;
            } else if (!this.$store.getters.getMainCompany.plan.trial_end && this.$store.getters.getMainCompany.created_at) {
              return moment(this.$store.getters.getMainCompany.created_at).isBefore(moment().subtract(7, "day")) ? true : false;
            } else {
              return true;
            }
          } else {
            return false;
          }
        } else {
          return false
        }
      } else {
        return false;
      }
    },
    isIos() {
      return Capacitor.getPlatform().toLowerCase() == "ios" ? true : false;
    },
    company() {
      return this.$store.getters.getCompany.company;
    },
  },
  methods: {
    carLabel,
    showEndMaintenance() {
      this.maintenance.start_insurance_date = moment(this.maintenance.last_maintenanced_date).add(this.maintenance.days_step, "days").format("YYYY-MM-DD");
      this.showEndMaintenanceDialog = true;
    },
    endInsuranceDate(date, days) {
      if (date) {
        return moment(date).add(days, "days").format("ll");
      } else {
        return "-";
      }
    },
    saveMaintenance() {
      // проверяем на должника
      if (this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.payer_state == 3) {
        this.$notify(this.$t("errors.payer_state_3_title"), this.$t("errors.payer_state_3_text"), "warning", 10000);
        return;
      }
      if (this.isStaff) {
        if (this.maintenance.car_id || (this.maintenance.car_ids && this.maintenance.car_ids.length > 0) && this.maintenance.title && this.maintenance.title.length > 0 && (!this.maintenance.periodic || (this.maintenance.days_step && this.maintenance.days_step > 0))) {
          this.isLoading = true;
          if (this.maintenance.last_maintenanced_date == null) {
            this.maintenance.last_maintenanced_date = moment().format("YYYY-MM-DD");
          }
          if (this.maintenance.periodic) {
            this.maintenance.started = false;
          }
          // remove next_maintenance_date
          delete this.maintenance.next_maintenance_date;
          this.axios
            .post("/api/v1/maintenances",
              {
                maintenance: this.maintenance,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              })
            .then((response) => {
              this.$notify(this.$t("maintenance.maintenance_created"), this.$t("maintenance.maintenance_created_text"), "success");
              this.showNewMaintenanceDialog = false;
              this.maintenance = {
                maintenance_type: 5,
                title: null,
                description: null,
                mileage_step: 0,
                days_step: 0,
                last_maintenanced_date: moment().format("YYYY-MM-DD"),
                criticality: 0,
                responsible: [],
                assign_to_all_cars: false,
                car_id: null,
                car_ids: [],
              };
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.maintenance_create"));
              console.log(error);
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("custom.no_data"), "", "warning");
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveEndInsurance() {
      if (this.isStaff) {
        if ((this.maintenance.start_insurance_date && this.maintenance.end_insurance_date) || this.maintenance.periodic == false) {
          let car = this.cars_with_maintenance.find((car) => car.id == this.maintenance.car_id);
          if (car) {
            this.isLoading = true;
            this.axios
              .post(`/api/v1/end_maintenance/${this.maintenance.id}`,
                {
                  maintenance: {
                    completed: true,
                    date_completed: moment().format("DD-MM-YYYY"),
                    mileage_completed: this.maintenance.last_maintenanced_mileage ? this.maintenance.last_maintenanced_mileage : car.mileage,
                    whois_ended: this.$store.getters.getCurrentUser.id,
                    description: this.maintenance.description,
                    days_step: this.maintenance.periodic ? moment(this.maintenance.end_insurance_date).diff(moment(this.maintenance.start_insurance_date), 'days') : 0,
                    last_maintenanced_date: this.maintenance.start_insurance_date ? this.maintenance.start_insurance_date : moment().format("YYYY-MM-DD"),
                    contractor_id: this.maintenance.contractor_id,
                  },
                },
                {
                  headers: {
                    Authorization: this.$store.getters.getAuthToken,
                  },
                })
              .then((response) => {
                // remove maintenance from array
                let car = this.cars_with_maintenance.find((car) => car.id == this.maintenance.car_id);
                let current_maintenances = car.maintenances
                current_maintenances.splice(current_maintenances.indexOf(this.maintenance), 1);
                // car.maintenances = current_maintenances;
                // this.cars_with_maintenance.splice(this.cars.indexOf(car), 1, car);

                this.$notify(this.$t("maintenance.maintenance_ended"), this.$t("maintenance.maintenance_ended_text"), "success");
                this.showEndMaintenanceDialog = false;
                this.maintenance = {
                  maintenance_type: 5,
                  title: null,
                  description: null,
                  mileage_step: 0,
                  days_step: 0,
                  last_maintenanced_date: moment().format("YYYY-MM-DD"),
                  notify_before: 0,
                  criticality: 0,
                  responsible: [],
                  assign_to_all_cars: false,
                  car_id: null,
                  car_ids: [],
                };
              })
              .catch((error) => {
                this.setError(error, this.$t("errors.error"));
                console.log(error);
              })
              .finally(() => (this.isLoading = false));
          } else {
            this.$notify(this.$t("errors.error"), this.$t("errors.error"), "warning");
          }
        } else {
          this.$notify(this.$t("custom.no_data"), "", "warning", 3000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveEditMaintenance() {
      if (this.isStaff) {
        this.isLoading = true;
        let maintenance_data = this.maintenance
        if (maintenance_data.started == false) {
          maintenance_data.date_start = null;
        }
        this.axios
          .patch(`/api/v1/maintenances/${this.maintenance.id}`,
            {
              maintenance: maintenance_data,
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
          .then((response) => {
            // update maintenance from array
            let car = this.cars_with_maintenance.find((car) => car.id == this.maintenance.car_id);
            let current_maintenances = car.maintenances
            current_maintenances.splice(current_maintenances.indexOf(this.maintenance), 1, this.maintenance);
            car.maintenances = current_maintenances;
            this.cars_with_maintenance.splice(this.cars_with_maintenance.indexOf(car), 1, car);
            this.$notify(this.$t("maintenance.maintenance_updated"), this.$t("maintenance.maintenance_updated_text"), "success", 3000);
            this.showEditMaintenanceDialog = false;
            this.maintenance = {
              maintenance_type: 5,
              title: null,
              description: null,
              mileage_step: 0,
              days_step: 0,
              last_maintenanced_date: moment().format("YYYY-MM-DD"),
              notify_before: 0,
              criticality: 0,
              responsible: [],
              assign_to_all_cars: false,
              car_id: null,
              car_ids: [],
            };
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.maintenance_create"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    addStartDateToMaintenance(maintenance) {
      let car = this.cars_with_maintenance.find((car) => car.id == maintenance.car_id);
      if (car) {
        let index = car.maintenances.findIndex((m) => m.id == maintenance.id)
        console.log("index", index);
        if (index > -1) {
          car.maintenances[index].date_start = moment().format("YYYY-MM-DD");
          this.cars_with_maintenance.splice(this.cars.indexOf(car), 1, car);
        }
      }
    },
    checkMaintenanceIcon(maintenance) {
      function checkDate(maintenance) {
        if (moment(maintenance.last_maintenanced_date).add(maintenance.days_step, 'days').diff(moment(), 'days') <= 0) {
          return true;
        } else {
          return false;
        }
      }
      if (this.isMobile) {
        return false;
      } else {
        if (maintenance.periodic) {
          if (maintenance.last_maintenanced_date && maintenance.days_step && checkDate(maintenance)) {
            return "mdi-alert-box";
          } else {
            return "mdi-all-inclusive-box-outline";
          }
        } else {
          if (maintenance.last_maintenanced_date && maintenance.days_step && checkDate(maintenance)) {
            return "mdi-alert-box";
          } else {
            return "mdi-numeric-1-box-outline";
          }
        }
      }
    },
    updateDaysStemp() {
      if (this.maintenance.next_maintenance_date && this.maintenance.last_maintenanced_date) {
        this.maintenance.days_step = moment(this.maintenance.next_maintenance_date).diff(moment(this.maintenance.last_maintenanced_date), 'days')
      }
    },
    nextMaintenance(maintenance) {
      if (maintenance.last_maintenanced_date && maintenance.days_step && moment(maintenance.last_maintenanced_date).isValid()) {
        return moment(maintenance.last_maintenanced_date).add(maintenance.days_step, 'days').format("ll");
      } else {
        return "?";
      }
    },
    async deleteMaintenance(maintenance) {
      if (this.isStaff) {
        const confirmed = await this.$confirm({
          title: this.$t("maintenance.delete_maintenance_title"),
          text: this.$t("maintenance.delete_maintenance_text"),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.you_sure_yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.you_sure_no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
        
        if (confirmed) {
          this.isLoading = true;
          this.axios
            .delete(`/api/v1/maintenances/${maintenance.id}`, {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
            .then(() => {
              // remove maintenance from array
              let car = this.cars_with_maintenance.find((car) => car.id == maintenance.car_id);
              let current_maintenances = car.maintenances
              current_maintenances.splice(current_maintenances.indexOf(maintenance), 1);
              car.maintenances = current_maintenances;
              // deep update car maintenance
              this.cars_with_maintenance.find((car) => car.id == maintenance.car_id).maintenances = Object.assign([], car.maintenances);

              this.$notify(this.$t("maintenance.maintenance_deleted"), "", "success", 3000);
            })
            .catch((error) =>
              this.setError(error, this.$t("errors.error"))
            )
            .finally(() => (this.isLoading = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    loadContractors() {
      this.isLoadingContractors = true;
      this.axios
        .get(
          `/api/v1/contractors`,
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          response.data.data.forEach((element) => {
            this.contractors.push(element.attributes);
          });
        })
        .catch((error) => {
          this.isLoadingContractors = false;
          this.setError(error, this.$t("errors.error"));
          console.log(error);
        })
        .finally(() => (this.isLoadingContractors = false));
    },
    checkPartnerAccess() {
      if (this.user_role == "partner") {
        this.isLoading = true;
        this.axios.get(`/api/v1/check_partner_access`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        }).then((response) => {
          if (!response.data.can_view_maintenances) {
            this.$router.push({ path: "/investor_analytics" });
            this.$notify(this.$t("errors.no_access"), "", "warning");
          }
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
        })
        .finally(() => (this.isLoading = false));
      }
    },
    customSearch(value, search, item) {
      return Object.values(item).some(v => v && v.toString().toLowerCase().includes(search.toLowerCase()))
    },
    customSort(items, index, isDescending) {
      // сортируем у тех у кого нет ТО
      let items_without_maintenance = items.filter((item) => item.maintenances.length == 0);
      // отнимаем из общего массива тех у кого нет ТО
      let items_with_maintenance = items.filter((item) => item.maintenances.length > 0);
      items_with_maintenance.sort((a, b) => {
        // сортировка по дате последнего ТО
        a.maintenances.sort((a, b) => {
          if (a.date_start && b.date_start) {
            return moment(a.date_start).diff(moment(b.date_start)) > 0;
          } else {
            return false;
          }
        });
        b.maintenances.sort((a, b) => {
          if (a.date_start && b.date_start) {
            return moment(a.date_start).diff(moment(b.date_start)) > 0;
          } else {
            return false;
          }
        });
        return moment(a.maintenances[0].date_start).diff(moment(b.maintenances[0].date_start)) > 0;
      });

      items_with_maintenance.sort((a, b) => {
        let minus_step_b = moment(b.maintenances[0].last_maintenanced_date).subtract(b.maintenances[0].days_step, 'days');
        let minus_step_a = moment(a.maintenances[0].last_maintenanced_date).subtract(a.maintenances[0].days_step, 'days');
        return minus_step_b.diff(moment()) - minus_step_a.diff(moment());
      })

      // присоединяем к отсортированному массиву тех у кого нет ТО в конец
      items_with_maintenance = items_with_maintenance.concat(items_without_maintenance);


      return items_with_maintenance;
    },
    formatLastMaintenancedDate(date) {
      if (date) {
        return moment(date, "YYYY-MM-DD").format("LL");
      } else {
        return null;
      }
    },
    selectCriticalityClass(criticality) {
      if (criticality == 0) {
        return "secondary white--text";
      } else if (criticality == 1) {
        return "warning white--text";
      } else if (criticality == 2) {
        return "error white--text";
      }
    },
    findWorkersName(ids) {
      let names = [];
      ids.forEach((id) => {
        this.workers.forEach((worker) => {
          if (worker.id == id) {
            names.push(worker.name);
          }
        });
      });
      return names ? names.join(", ") : "";
    },
    formatDate(date) {
      if (date) {
        return moment(date, "YYYY-MM-DD").format("LL");
      } else {
        return "-";
      }
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
    goBack() {
      var numberOfEntries = window.history.length;
      if (numberOfEntries > 2) {
        this.$router.go(-1);
      } else {
        var fpath = this.PageData.backCrumb.url;
        this.$router
          .push({
            path: fpath,
          })
          .catch((err) => { });
      }
    },
  },
};
</script>
<style></style>
